import { css } from "@emotion/css";

import { grey } from "@/modules/theme/utils/colors";
import { Theme } from "@/modules/theme/utils/createTheme";

export const createUndoneSubtaskStyles = ({
  spacing,
  borderRadius,
  typography,
}: Theme) => {
  return {
    root: css({
      backgroundColor: grey[100],
      borderRadius: borderRadius.medium,
      padding: spacing(1.5),
      minHeight: 80,
      width: "100%",
      display: "grid",
      gridTemplateColumns: "1fr 80px",
      fontWeight: typography.fontWeight.medium,
      marginBottom: spacing(1),
    }),
    name: css({
      fontSize: typography.pxToRem(15),
    }),
    points: css({
      placeSelf: "start end",
    }),
  };
};
